import { useContext } from "react";
import { useSelector } from "react-redux";
import { TaskStatusCreationError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: TaskStatusCreationError;
  createTaskStatus(request: Boundaries["createTaskStatus"]["request"]): void;
}

function useTaskStatusCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isTaskStatusCreationRequestPending),
    isRequestSuccess: useSelector(selector.isTaskStatusCreationRequestSuccess),
    isRequestFailure: useSelector(selector.isTaskStatusCreationRequestFailure),
    error: useSelector(selector.getTaskStatusCreationError),
    createTaskStatus: core.createTaskStatus,
  };
}

export { useTaskStatusCreation };
